import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * @typedef {object} Team
 * @property {string} id The team id
 * @property {string} name The team name
 * @property {string} organizationId The org this team belongs to
 * @property {Date} createdAt When the team was created
 */

/**
 * Load a team by ID with membership verification
 * @param {string} teamId The id of the team
 * @param {string} userId The id of the user trying to access
 * @returns {Promise<Team|null>} The team or null if not found/not a member
 */
export async function loadTeam(teamId, userId) {
  const isMember = await FirebaseAdapter().membership.checkTeamAccess(
    userId,
    teamId,
  );

  if (!isMember) {
    return null;
  }

  const team = await FirebaseAdapter().teams.getTeam(teamId);

  if (!team) {
    return null;
  }

  return {
    id: team.id,
    name: team.name,
    organizationId: team.organizationId,
    createdAt: team.createdAt?.toDate
      ? team.createdAt.toDate()
      : team.createdAt,
  };
}
